import { atom } from "jotai";

export interface INotificationOutbox {
    id?: number;
    type: string;
    payload: any;
    status: string;
    attempts?: number;
    created_at?: string;
    updated_at?: string;
}

export interface INotificationOutboxInput extends Omit<INotificationOutbox, 'id' | 'created_at' | 'updated_at'> {}

export const notificationOutboxAtom = atom<INotificationOutbox[]>([]);
export const notificationOutboxLoadingAtom = atom<boolean>(false);

